import { Loader2Icon } from 'lucide-react'
import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

import type { ChatPinnedMessage } from './chat-header.interface'
import { formatPinnedDate, truncateContent } from './chat-pinned-message.helper'

interface ChatPinnedMessageItemProps {
  message: ChatPinnedMessage
  isJumping?: boolean
  onClick: () => void
}

/**
 * Individual pinned message item displayed in the pinned messages popover.
 * Shows an inline spinner when a scroll-to-pinned is in progress for this item.
 */
export const ChatPinnedMessageItem: FC<ChatPinnedMessageItemProps> = ({
  message,
  isJumping = false,
  onClick,
}): ReactNode => (
  <button
    type="button"
    onClick={onClick}
    className={cn(
      'chat-header-pinned-item flex w-full flex-col gap-1 rounded-md px-3 py-2 text-left',
      'hover:bg-accent focus:bg-accent focus:outline-none',
      'transition-colors'
    )}
  >
    <p className="text-sm leading-snug">{truncateContent(message.content)}</p>
    <div className="flex items-center gap-1.5 text-xs text-muted-foreground">
      <span>Pinned by {message.pinnedBy.name}</span>
      <span>·</span>
      <span>{formatPinnedDate(message.pinnedAt)}</span>
      {isJumping && <Loader2Icon className="ml-auto size-3 animate-spin" />}
    </div>
  </button>
)

ChatPinnedMessageItem.displayName = 'ChatPinnedMessageItem'
